import { CookieFunction } from '../../types/CookieFunction.types.js';
import { LocaleInfo } from '../../types/script-data/LocaleInfo.types.js';
import { SuspendedAccountData } from '../../types/script-data/SuspendedAccountData.types.js';

import cookie from '../../util/cookie.js';
import { getData } from '../../util/script_data.js';

import { showSuspendedAccountDialog } from '../dialogs/AccountSuspendedDialog.js';
import { showKoreanBrowseFontsDialog } from '../dialogs/KoreanBrowseFontsDialog.js';

const COOKIE_ID_SAW_KOREAN_BROWSE_FONTS_DIALOG = 'adobe-fonts-saw-korean-browse-fonts-dialog';
const KOREAN_LOCALE = 'ko_KR';

const shouldShowKoreanBrowseFontsDialog = (selectedLocale: string) => {
  const hasOptedOutKoreanBrowseFontsDialog = (cookie as unknown as CookieFunction)(COOKIE_ID_SAW_KOREAN_BROWSE_FONTS_DIALOG);
  if (hasOptedOutKoreanBrowseFontsDialog) {
    return false;
  }

  return selectedLocale === KOREAN_LOCALE;
};

/**
 * Only one modal-type dialog should be rendered on initial page load.
 */
export const handlePageLoad = () => {
  const suspendedAccountData = getData('suspended-account-data') as SuspendedAccountData;
  if (suspendedAccountData.hasSuspendedAccount) {
    showSuspendedAccountDialog();
  } else {
    const localeInfo = getData('/locale_info') as LocaleInfo;
    if (shouldShowKoreanBrowseFontsDialog(localeInfo.selectedLocale)) {
      showKoreanBrowseFontsDialog();
    }
  }
};

export const registerEventHandlers = () => {
  window.addEventListener('DOMContentLoaded', handlePageLoad);
};
